export default function FeatureGridSection() {
  const features = [
    {
      icon: 'ri-search-line',
      title: 'Schneller suchen',
      description: 'Vergleiche Produkte ohne lange Suche. Das OOPBUY Spreadsheet bietet direkten Zugriff auf tausende gepr\u00fcfte Artikel mit allen relevanten Informationen auf einen Blick.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Besser vergleichen',
      description: 'Bewerte Preise, Qualit\u00e4t und Verk\u00e4uferbewertungen nebeneinander. Die strukturierte \u00dcbersicht macht Preisvergleiche einfach und transparent.',
    },
    {
      icon: 'ri-timer-line',
      title: 'Zeit sparen',
      description: 'Fertige Listen reduzieren deine Recherchezeit erheblich. Statt stundenlang zu suchen, findest du passende Produkte in Minuten.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sicherer einkaufen',
      description: 'Verstehe Risiken und Best Practices. Mit gepr\u00fcften Verk\u00e4uferinformationen und QC-Tipps minimierst du Fehlk\u00e4ufe.',
    },
    {
      icon: 'ri-global-line',
      title: 'Deutsche Erkl\u00e4rung',
      description: 'Alle Informationen sind auf Deutsch verf\u00fcgbar. Keine \u00dcbersetzungsfehler, keine Verst\u00e4ndnisprobleme \u2013 klare Anleitungen f\u00fcr den deutschen Markt.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regelm\u00e4\u00dfige Updates',
      description: 'Das OOPBUY Spreadsheet 2026 wird kontinuierlich aktualisiert. Neue Produkte, aktuelle Preise und frische Bewertungen halten dich auf dem neuesten Stand.',
    },
  ];

  return (
    <section id="vorteile" className="py-16 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="mb-12">
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">Warum ein Spreadsheet nutzen?</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            Warum nutzen immer mehr K&auml;ufer<br />ein OOPBUY Spreadsheet?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-8 hover:bg-background-100 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}